import { render, staticRenderFns } from "./helpDetails.vue?vue&type=template&id=f3380e66&scoped=true"
import script from "./helpDetails.vue?vue&type=script&lang=js"
export * from "./helpDetails.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=f3380e66&prod&scoped=true&lang=css&external"
import style1 from "./helpDetails.vue?vue&type=style&index=1&id=f3380e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3380e66",
  null
  
)

export default component.exports